define('controllers/occupancyrestriction',['require'],function(require) {
	return function() {		
		$(function () {
			var occupancyData = ServerData.feData.occupancyData;
			var yearToUpdate = occupancyData.yearToShow;
			var monthToUpdate = occupancyData.monthToShow;
			var disableCalendar = occupancyData.disableCalendar;
			var hotelId = occupancyData.hotelId;
			
			var saveButtons = $("#btnSave, #btnSaveAndFinalize"),
				$Error = $("#Error"),
				chkNoRooms = $("#chkNoRooms");

			chkNoRooms.on("change", function () {
				if (chkNoRooms.is(':checked')) {
					$("#occupancyTable td[data-day].btn-primary").removeClass("btn-primary");
				}
			});

			function refreshChkNoRooms() {
				var noDatesSelected = $("#occupancyTable td[data-day].btn-primary").length == 0
				if (noDatesSelected) { //no dates selected
					chkNoRooms.prop('checked', true);
				} else {
					chkNoRooms.prop('checked', false);
				}
			}

			if (disableCalendar) {
				disableSaveFunctionality();
			}
			function disableSaveFunctionality() {
				saveButtons.hide();
				chkNoRooms.hide();
				$("#chkNoRoomsLabel").hide();
				disableCalendar = true;
			}

			$("#occupancyTable td[data-day]").on("click", function () {
				if (disableCalendar) {
					disableSaveFunctionality();
					$Error.show().html("You've finalized this month and can no longer edit it.");
				} else {
					$(this).toggleClass("btn-primary");
					refreshChkNoRooms();
				}
			});

			saveButtons.on("click", function () {
				var $this = $(this),
					occupancyDates = [],
					$info = $("#info"),
					finalize = $this.prop('id') == "btnSaveAndFinalize",
					loading = finalize ? $("#loadingFinalize") : $("#loadingSave");

				if (!finalize || (finalize && confirm("Are you sure you'd like to finalize these dates? You won't be able to modify this month's occupancy afterward."))) {
					$info.hide();
					$Error.hide();
					$this.hide();
					loading.show();

					$("#occupancyTable td[data-day].btn-primary").each(function () {
						occupancyDates.push("{0}/{1}/{2}".format(monthToUpdate, $(this).attr("data-day"), yearToUpdate));
					});

					$.ajax({
						type: 'POST',
						url: "hotelOccupancySave.aspx",
						data: { occupancyDates: occupancyDates.join(","), HotelId: hotelId, finalize: finalize, Month: monthToUpdate, Year: yearToUpdate },
						success: function (info) {
							var obj = {};
							try {
								obj = JSON.parse(info);
							} catch (err) { }

							if (obj.error != undefined) {
								$Error.show().html(obj.error);
							} else {
								$info.show().html(info);
							}

							$this.show();
							loading.hide();

							if (finalize) disableSaveFunctionality();
						},
						error: function () {
							$Error.show().html("Something went wrong. Please re-load the page and try again or contact Adestinn Support.");
							$this.show();
							loading.hide();
						}
					});
				}
			});

			$("#ddlReports").on("change", function () {
				$(this).next().show();
			});
		});
	};
});
